/* Gummy Maker draft only. No dependencies, polling or customer tracking. */
(() => {
  const init = () => {
    const root = document.querySelector('[data-gmc-selection]')?.closest('section');
    if (!root || root.dataset.gmcReady) return;
    root.dataset.gmcReady = 'true';
    document.body.classList.add('gmc-inline-chat');
    const setupChat = () => {
      const api = window.tidioChatApi;
      if (!api || document.body.dataset.gmcChatReady) return;
      document.body.dataset.gmcChatReady = 'true';
      api.hide();
      api.on('close', () => {
        document.body.classList.remove('gmc-chat-open');
        api.hide();
      });
    };
    if (window.tidioChatApi) {
      window.tidioChatApi.on('ready', setupChat);
      setupChat();
    } else document.addEventListener('tidioChat-ready', setupChat, {once:true});
    const showKitImage = (gallery, target) => {
      const slides = Array.from(gallery.querySelectorAll('[data-gmc-kit-slide]'));
      slides.forEach((el,index) => { el.hidden = index !== target; });
      gallery.querySelectorAll('[data-gmc-kit-image]').forEach(el => { el.setAttribute('aria-pressed', String(Number(el.dataset.gmcKitImage) === target)); });
      gallery.querySelector('[data-gmc-kit-image-status]').textContent = `YUMMY GUMMY Kit · Image ${target+1} of ${slides.length}`;
      const rail = gallery.querySelector('.gmc-kit-thumbnails');
      const active = rail.querySelector('[aria-pressed="true"]');
      if (active) rail.scrollTo({top:Math.max(0,active.offsetTop-rail.offsetTop-rail.clientHeight/2+active.clientHeight/2),behavior:'auto'});
    };
    root.querySelectorAll('.gmc-kit-stage').forEach(stage => {
      let start = null;
      stage.addEventListener('touchstart', event => { start = {x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}; }, {passive:true});
      stage.addEventListener('touchend', event => {
        if (!start) return;
        const dx=event.changedTouches[0].clientX-start.x, dy=event.changedTouches[0].clientY-start.y;
        start=null;
        if (Math.abs(dx)<45 || Math.abs(dx)<=Math.abs(dy)) return;
        const gallery=stage.closest('[data-gmc-kit-gallery]'), slides=Array.from(gallery.querySelectorAll('[data-gmc-kit-slide]'));
        const current=Math.max(0,slides.findIndex(el=>!el.hidden));
        showKitImage(gallery,(current+(dx<0?1:-1)+slides.length)%slides.length);
      }, {passive:true});
    });
    document.addEventListener('click', event => {
      if (event.target.closest('[data-gmc-chat]')) {
        const api = window.tidioChatApi;
        if (!api) {
          document.querySelectorAll('[data-gmc-chat-status]').forEach(el => { el.textContent = 'Chat is loading. Please try again in a moment.'; });
          return;
        }
        document.body.classList.add('gmc-chat-open');
        api.show();
        requestAnimationFrame(() => requestAnimationFrame(() => api.open()));
      }
      const direction = event.target.closest('[data-gmc-kit-direction]');
      const thumb = event.target.closest('[data-gmc-kit-image]');
      if (thumb || direction) {
        const gallery = (thumb || direction).closest('[data-gmc-kit-gallery]');
        const slides = Array.from(gallery.querySelectorAll('[data-gmc-kit-slide]'));
        const current = Math.max(0, slides.findIndex(el => !el.hidden));
        const target = thumb ? Number(thumb.dataset.gmcKitImage) : (current + Number(direction.dataset.gmcKitDirection) + slides.length) % slides.length;
        showKitImage(gallery, target);
      }
    });
    const machineTitle = root.querySelector('[data-gmc-title]');
    let setup = 'machine';
    const includedHandles = new Set(['magical-eat-to-treat-gummy-trays-10ml-2-pack-1','magical-21up-square-medible-trays-8ml-2-pack','premium-cherry-gummy-mix','premium-blue-raspberry-gummy-mix']);
    const filterIncluded = () => document.querySelectorAll('[data-gmc-accessory], .gmc-reco').forEach(el => {
      const handle = el.dataset.gmcAccessory || el.dataset.handle;
      el.hidden = (setup === 'kit' && includedHandles.has(handle)) || el.dataset.inCart === 'true';
    });
    const updatePaymentOptions = () => {
      const warranty = window.StandaloneWarrantySystem;
      const selected = warranty?.warrantyInputs.find(i => i.checked);
      const extended = !!(selected && warranty.getWarrantyData(selected).price > 0);
      root.querySelectorAll('[data-gmc-buy] .shopify-payment-button').forEach(el => { el.hidden = extended; });
      const note = root.querySelector('[data-gmc-warranty-note]');
      if (note) note.hidden = !extended;
    };
    root.addEventListener('change', event => {
      const input = event.target;
      if (input.matches('input[name^="gmc-setup-"]')) {
        const warranty = window.StandaloneWarrantySystem;
        if (warranty?.isProcessing) return;
        setup = input.value;
        root.querySelectorAll('[data-gmc-buy], [data-gmc-price], [data-gmc-content]').forEach(el => {
          el.hidden = (el.dataset.gmcBuy || el.dataset.gmcPrice || el.dataset.gmcContent) !== setup;
        });
        root.querySelector('[data-gmc-machine-gallery]').hidden = setup !== 'machine';
        root.querySelector('[data-gmc-kit-gallery]').hidden = setup !== 'kit';
        machineTitle.textContent = setup === 'kit' ? machineTitle.dataset.kitTitle : machineTitle.dataset.machineTitle;
        root.querySelector('[data-gmc-selection]').textContent = 'Selected: ' + (setup === 'kit' ? 'YUMMY GUMMY Kit' : 'Gummy Maker');
        if (warranty) {
          warranty.productForm = root.querySelector(`[data-gmc-buy="${setup}"] form`);
          warranty.submitButton = warranty.productForm.querySelector('[type="submit"]');
          warranty.priceContainer = root.querySelector(`[data-gmc-price="${setup}"] .price__container`);
          // Prices cached once per setup, so repeated selection never compounds warranty cost.
          warranty.setupPrices ||= {};
          if (!warranty.setupPrices[setup]) {
            warranty.originalPrices = {regular:0,sale:0,compare:0};
            warranty.storeOriginalPrices();
            warranty.setupPrices[setup] = {...warranty.originalPrices};
          }
          warranty.originalPrices = {...warranty.setupPrices[setup]};
          const selected = warranty.warrantyInputs.find(i => i.checked);
          if (selected) warranty.handleWarrantyChange({target:selected});
        }
        filterIncluded();
        updatePaymentOptions();
        document.dispatchEvent(new CustomEvent('gmc:setup-change', {detail:{setup}}));
      }
      if (input.matches('input[name="warranty"]')) updatePaymentOptions();
      if (input.matches('[data-gmc-accessory-variant]')) {
        const card = input.closest('.fp-card'), option = input.selectedOptions[0];
        card.dataset.variantId = input.value;
        card.dataset.priceCents = option.dataset.price;
        card.querySelector('[data-fp-add]').dataset.variantId = input.value;
        card.querySelector('.gmc-accessory-price').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(Number(option.dataset.price)/100);
      }
    });
    // Cache the untouched machine base before the first switch.
    const warranty = window.StandaloneWarrantySystem;
    if (warranty) warranty.setupPrices = {machine:{...warranty.originalPrices}};
    // Native Shopify recommendation results may arrive after the main section.
    const recoRoot = document.querySelector('product-recommendations.gmc-recos');
    if (recoRoot) {
      const observer = new MutationObserver(filterIncluded);
      observer.observe(recoRoot,{childList:true,subtree:true});
    }
    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-gmc-add]');
      if (!button || button.disabled) return;
      const card = button.closest('.gmc-reco'), status = card.querySelector('[role="status"]');
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sections = drawer?.getSectionsToRender?.().map(s => s.id);
      button.disabled = true; status.textContent = 'Adding…';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:button.dataset.gmcAdd,quantity:1}],...(sections?{sections,sections_url:location.pathname}:{})})});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || 'Could not add this item. Please try again.');
        status.textContent = 'Added to cart';
        if (drawer?.renderContents && data.sections) drawer.renderContents(data);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        card.dataset.inCart = 'true';
      } catch(error) { status.textContent = error.message; }
      finally { button.disabled = false; }
    });
    filterIncluded();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();

